export class Impuesto {
    idImpuesto: number;
    montoImpuesto: number;
    montoBase: number; // 'DET/valorVenta'
    porcentaje: string; // 18.00
    tipoAfectacion: string;
}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/emisorFacturas/recursos/modelo/impuesto.ts